import { createSlice } from "@reduxjs/toolkit";
import { fetchItems } from "./itemThunks";

const initialState = {
  categories: [],
  loading: false,
  error: null,
};

const itemSlice = createSlice({
  name: "items",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchItems.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload.Category || [];
        state.error = null;
      })
      .addCase(fetchItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.categories = [];
      });
  },
});

export default itemSlice.reducer;

